import React from 'react';
import { Trans, useTranslation } from 'react-i18next';

const Translations = ({ textKey, text, children, data = {}, backup = 'Unknown Text', components, render }) => {
    // Keep the hook unconditional when switching between plain text and rich text.
    const { t } = useTranslation();
    if (textKey) {
        return (
            <Trans
                t={t}
                i18nKey={textKey}
                values={data}
                count={data.count}
                components={components}
                defaults={children == null ? backup : undefined}
            >
                {children}
            </Trans>
        );
    }
    if (!text) return <>{backup}</>;
    const translated = t(text, { ...data, defaultValue: backup });
    return render ? render(translated) : <>{translated}</>;
};

export default Translations;
